export const INTEREST_OPTIONS = [
  'Hip Hop',
  'Ballet',
  'Salsa',
  'Contemporary',
  'Kathak',
  'Breakdance',
  'Multiple Styles',
  'Academy Plan'
];

export const LEVEL_OPTIONS = ['Beginner', 'Intermediate', 'Advanced', 'Professional'];

export const AGE_GROUP_OPTIONS = ['Kids (4-12)', 'Teens (13-19)', 'Adults (20+)', 'Seniors'];

export const TIME_SLOT_OPTIONS = ['Morning', 'Afternoon', 'Evening', 'Weekend Only'];

export const SOURCE_OPTIONS = ['Instagram', 'Facebook', 'Friend Referral', 'Google Search', 'Other'];
